import React from "react";
import { Image } from "react-bootstrap";

import "./AppDownloadButton.scss";
import useVendorDetection from "../../../hooks/useVendorDetection";
import useDisclosure from "../../../hooks/useDisclosure";
import {
  PhoneVendors,
  getVendorDownloadLink,
  getVendorLogo,
} from "../../../utils/vendor";
import Bonus from "../../Bonus/Bonus";
import DownloadAndroidAppModal from "../../DownloadAndroidAppModal/DownloadAndroidAppModal";

interface AppDownloadButtonProps {
  onAndroidDownload?: () => void;
}

function AppDownloadButton({ onAndroidDownload }: AppDownloadButtonProps) {
  const phoneVendor = useVendorDetection();
  const {
    isOpen: isAndroidDownloadOpen,
    onOpen: openAndroidDownload,
    onClose: closeAndroidDownload,
  } = useDisclosure();

  const handleClick = (): void => {
    const storeLink = getVendorDownloadLink(phoneVendor);

    if (phoneVendor !== PhoneVendors.SAMSUNG && storeLink) {
      window.open(storeLink, "_blank", "noopener,noreferrer");
      return;
    }

    (onAndroidDownload ?? openAndroidDownload)();
  };

  return (
    <>
      <span className="position-relative">
        <Bonus />
        <button
          onClick={handleClick}
          className="app-download font-reg"
          aria-label="download"
        >
          <span className="img-container">
            <Image
              src={getVendorLogo(
                phoneVendor === PhoneVendors.SAMSUNG ? null : phoneVendor
              )}
              alt="vendor"
            />
          </span>
          <span className="download-app-text">download hyper gaming app</span>
        </button>
      </span>
      {!onAndroidDownload && (
        <DownloadAndroidAppModal
          isOpen={isAndroidDownloadOpen}
          onClose={closeAndroidDownload}
        />
      )}
    </>
  );
}

export default AppDownloadButton;
